import ExtractionComponent from "~/components/pages/supervisor/extraction";

export default function ExtractionPage() {
  return (
    <div>
      <ExtractionComponent />
    </div>
  );
}
